import GalleryWindow from './Components/GalleryWindow';
import Header from './Components/Header';
import AboutWindow from './Components/AboutWindow';
import TaskBar from './Components/TaskBar';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SocialsWindow from './Components/SocialsWindow';
import { useState } from 'react';
import BootScreen from './Components/BootScreen';

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [showBoot, setShowBoot] = useState(true);
  return (
    <>
      {showBoot && (
        <BootScreen isLoading={isLoading} onShowPage={setShowBoot} />
      )}

      <>
        <div id="wrapper">
          <Container
            fluid
            style={{ paddingBottom: '50px' }}
            className={!showBoot ? 'fadeIn' : ''}
          >
            <Row>
              <Col lg={4} md={6}>
                <Header />
                <AboutWindow />
                <SocialsWindow />
              </Col>
              <Col lg={8} md={6}>
                <GalleryWindow setIsLoading={setIsLoading} />
              </Col>
            </Row>
          </Container>
          <TaskBar />
        </div>
      </>
    </>
  );
}

export default App;
